export const CANDIDATE_DETAILS_EN = {
  chat: {
    header: 'Write your feedback here',
    toggleButton: 'Chat with {{ managerName }}',
    toggleButton_open: '$t(candidateDetails.chat.header)',
    toggleCloseHint: 'Close',
    fullScreenButton: 'Fullscreen',
    sendButtonAriaLabel: 'Send',
    message: {
      heading:
        '{{ authorFullName }} - $t(common.formatting.date.dateFormat) at $t(common.formatting.date.dateFormat_time)',
      defaultMessageFeedback:
        'Hello {{ name }}, if you have something to communicate feel free to use the chat.',
      defaultMessageFeedback_positive:
        'Hello {{ name }}, why <strong>is he/she interesting</strong>? Would you like to deepen some specific aspects during the interview?',
      defaultMessageFeedback_negative:
        'Hello {{ name }}, tell me your reasons so I can refine the search for candidates.',
    },
  },
  dossier: {
    title: 'Summary & CV',
    subtitle: 'Job interview',
    button: 'Download dossier',
    showCurriculumButton: 'Show CV',
    modalTitle:
      '{{ candidateFullName }} | $t(candidate.sections.curriculum.title)',
    modalCloseButtonAriaLabel: 'Close',
  },
  feedback: {
    bubble:
      'Would you like to learn more about {{ candidateFullName }} through an <strong>interview</strong>?',
    bubble_interested:
      '<strong>{{ candidateFullName }}</strong> is interesting',
    bubble_notInterested:
      '<strong>{{ candidateFullName }}</strong> is not interesting',
    bubble_discarded:
      '<strong>{{ candidateFullName }}</strong> does not proceed.',
    actionYes: 'Yes',
    actionNo: 'No',
    actionChangeFeedback: 'Have you changed your mind?',
    interesting: 'Interesting',
  },
  info: {
    age: '{{ age }} years',
    drivingTime: {
      hours: '<strong>{{ hours }}</strong>h',
      minutes: '<strong>{{ minutes }}</strong>min',
    },
  },
  intro: {
    editLink: 'Edit application',
  },
  negativeFeedback: {
    title: 'Why are they not interesting?',
    subtitle:
      'Knowing why you do not consider this candidate suitable for the position (e.g., skills, seniority, etc.) helps us present only candidates perfectly in line with your expectations.',
    notesLabel: 'Write the motivation:',
    notesPlaceholder:
      'The motivation will be sent to the headhunter handling the selection',
    submit: 'Send',
    cancel: 'Cancel',
    successTitle: 'Message sent:',
    successSubtitle: 'We have sent your feedback to the headhunter',
    successClose: 'Ok, thank you',
  },
  scout: {
    accordionOpen: 'Open',
    accordionClose: 'Close',
    title: 'Report scout',
    accordionTitle_skillsAssessment: 'Skills evaluation',
    accordionTitle_overallAssessment: 'Role summary',
    button: 'Download report',
  },
};
